module.exports = __webpack_public_path__ + "static/media/features-section-4.995b5eb2.png";